export const SMALL_DEVICE_MAX_SIZE = '680px';

export default {
  SMALL_DEVICE_MAX_SIZE,
};

export const MOBILE_WIDTH_RESOLUTION = 1024;

export const LEGAL_FORMS = {
  INDIVIDUAL: 'individual',
  ADMINISTRATION: 'administration',
  CORPORATION: 'corporation',
  PERSONALCORPORATION: 'personalcorporation',
  ASSOCIATION: 'association',
  OTHER: 'other',
};
